import { tsExternalModuleReference } from "@babel/types";

export function getQuickSortAnimations(array) {
    const animations = [];
    quickSort(array, 0, array.length - 1, animations);
    return animations;
}

function quickSort(array, low, high, animations) {
    if (low < high) {
        // pi is partition index, array[pi] is now at right place
        const pi = partition(array, low, high, animations);
        animations.push(['done', pi]);

        quickSort(array, low, pi - 1, animations);
        // this partition is sorted, push them to change color
        for(let i = low; i < pi; i++) {
            animations.push(['done', i]);
        }
        quickSort(array, pi + 1, high, animations);
        // this partition is sorted, push them to change color
        for(let i = pi+1; i <= high; i++) {
            animations.push(['done', i]);
        }
    }
    return array;
}

function partition(array, low, high, animations) {
    // pivot - the rightmost element
    const pivot = array[high];

    // push the pivot to change color
    animations.push(['pivot', high, true]);

    // this is the position to place smaller elements
    let i = low;
    animations.push(['position', i, true]);

    for(let j = low; j <= high - 1; j++) {
        // this is the element we are scaning, push it to change color
        animations.push(['scan', j, true]);        
        // if we are scaning the element at position i, revert it back to special color
        if(i === j) {
            animations.push(['position', j, true]);
        } else {
            // else revert back to normal color
            animations.push(['scan', j, false]);
        };

        // if current element is smaller than the pivot
        if(array[j] < pivot) {
            // swap the height of element i and j
            animations.push(['swap', i, array[j]]);
            animations.push(['swap', j, array[i]]);

            // swap it with the element at the position i
            const temp = array[i];
            array[i] = array[j];
            array[j] = temp;      

            // revert the color of position i
            animations.push(['position', i, false]);
            // advance the position to place next smaller element
            i++;
            // push the new position to change the color
            animations.push(['position', i, true]);
        }
    }
    // swap the height of element i and the pivot
    animations.push(['swap', i, pivot]);
    animations.push(['swap', high, array[i]]);

    // pivot is at final sorted position, revert the color
    animations.push(['position', i, false]);
    // high is no longer a pivot, push it to revert its color
    animations.push(['pivot', high, false]);

    // swap the pivot with the element at the position i
    array[high] = array[i];
    array[i] = pivot;
    return i;
}

// function test() {
//     for(let i = 0; i < 100; i++) {
//         const array1 = []; 
//         const array2 = [];
//         const animations = [];
//         const length = randomIntFromInterval(1, 1000);
//         for(let i = 0; i < length; i++){
//             const value = randomIntFromInterval(-1000, 1000);
//             array1.push(value);
//             array2.push(value);
//         }
//         const jsArray = array1.sort((a, b) => a - b);
//         const myArray = quickSort(array2, 0, array2.length - 1, animations);
//         console.log(arraysAreEqual(jsArray, myArray));
//     }
// }